import { RouteConfig } from "vue-router";

const cajaChicasSantiagoVV: RouteConfig = {
  path: "/cajaChicasSantiagoVV",
  name: "cajaChicasSantiagoVV",
  component: () => import(/* webpackChunkName: "caja-chicas-santiago-vv" */ "@/views/CajaChicasSantiagoVV.vue"),
};

export default cajaChicasSantiagoVV;
